
import { append } from "./fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { concat } from "./fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Operators_IsNull } from "./fable_modules/fable-library-js.5.0.0-rc.2/FSharp.Core.js";

const scriptId = "hs-script-loader";

function onReadyCallbacks() {
    const existing = window.hsConversationsOnReady;
    if (existing == null) {
        return [];
    }
    else {
        return existing;
    }
}

function whenReady(action) {
    const conversations = window.HubSpotConversations;
    if (conversations == null) {
        window.hsConversationsOnReady = append(onReadyCallbacks(), [() => {
            action(window.HubSpotConversations);
        }]);
    }
    else {
        action(conversations);
    }
}

function appendScript(portalId, onError) {
    const script = document.createElement("script");
    script.id = scriptId;
    script.type = "text/javascript";
    script.async = true;
    script.defer = true;
    script.src = concat("https://js-eu1.hs-scripts.com/", portalId, ...".js");
    script.onerror = ((_arg) => {
        onError();
    });
    document.body.appendChild(script);
}

export function loadInline(settings, containerSelector, callbacks) {
    window.hsConversationsSettings = {
        loadImmediately: false,
        inlineEmbedSelector: containerSelector,
        identificationEmail: settings.IdentificationEmail,
        identificationToken: settings.IdentificationToken,
    };
    if (Operators_IsNull(document.getElementById(scriptId))) {
        appendScript(settings.PortalId, callbacks.OnFailed);
    }
    whenReady((conversations) => {
        conversations.mwkInlineCallbacks = callbacks;
        const currentCallbacks = () => conversations.mwkInlineCallbacks;
        if (conversations.mwkInlineListeners == null) {
            conversations.mwkInlineListeners = true;
            conversations.on("widgetLoaded", ((_arg) => {
                currentCallbacks().OnLoaded();
            }));
            conversations.on("widgetHidden", ((payload) => {
                const description = payload.description;
                currentCallbacks().OnHidden((description == null) ? "" : description);
            }));
            conversations.on("unreadConversationCountChanged", ((payload_1) => {
                const unreadCount = payload_1.unreadCount;
                currentCallbacks().OnUnreadCountChanged((unreadCount == null) ? 0 : unreadCount);
            }));
        }
        const status = conversations.widget.status();
        if (!(status == null) && status.loaded) {
            callbacks.OnLoaded();
        }
        else {
            conversations.widget.load();
        }
    });
}

export function relayout() {
    window.dispatchEvent(new Event("resize"));
}

export function hide() {
    window.hsConversationsOnReady = [];
    const conversations = window.HubSpotConversations;
    if (!(conversations == null)) {
        conversations.widget.remove();
        conversations.clear({
            resetWidget: true,
        });
    }
}

